import { render, staticRenderFns } from "./TelegramSetup.vue?vue&type=template&id=45c4dd8e&scoped=true&"
import script from "./TelegramSetup.vue?vue&type=script&lang=js&"
export * from "./TelegramSetup.vue?vue&type=script&lang=js&"
import style0 from "./TelegramSetup.vue?vue&type=style&index=0&id=45c4dd8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4dd8e",
  null
  
)

export default component.exports